import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, "Data website", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.DownloadBerichten && _ctx.DownloadBerichten(...args)))
    }, "Download de berichten in excel"),
    _hoisted_2,
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.DownloadNews && _ctx.DownloadNews(...args)))
    }, "Download de inschrijvingen aan de newsletter in excel")
  ], 64))
}